<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Agendar tarefa</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs2>
        <v-container fluid class="py-2">
          <v-layout row wrap>
            <v-flex xs12>
              <v-btn flat @click.stop="onSubmit" :disabled="isFormInvalid">
                <span class="subtitulo">Salvar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <form v-on:submit.prevent="onSubmit">
      <v-layout row wrap class="pt-5">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid class="px-0">
            <v-layout wrap class="ma-0">
              <v-flex xs12 class="pa-0">                
                <v-dialog v-model="dialogTarefasTipos" fullscreen transition="dialog-bottom-transition" :overlay="false" @input="menuData = false">
                  <v-text-field
                    slot="activator"
                    v-model="form.fields.tipo"
                    label="Tipo de tarefa"
                    v-validate="'required'"
                    name="tipo"
                    data-vv-as="tipo"
                    :error-messages="errors.has('tipo') ? errors.first('tipo') : []"
                    single-line
                    full-width
                    hide-details
                    prepend-icon="event_available"
                    readonly
                    class="label_fix"
                    v-show="!dialogTarefasTipos"
                  >
                  </v-text-field>
                  <v-card>
                    <v-toolbar dark class="primary">
                      <v-btn icon @click.native="dialogTarefasTipos = false" dark>
                        <v-icon>keyboard_arrow_left</v-icon>
                      </v-btn>
                      <v-toolbar-title>Tarefa</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn dark flat @click.native="dialogTarefasTipos = false">Concluir</v-btn>
                      </v-toolbar-items>
                    </v-toolbar>
                    <v-list>
                      <v-list-tile v-for="(item, index) in tarefaTipo" v-bind:key="item.id" @click.native="selectTarefa(item)">
                        <v-list-tile-action>
                          <v-icon v-if="index === 0">event_available</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ item }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="form.fields.tipo === item">
                          <v-icon class="secondary--text">done</v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon v-if="tarefaTipo.length === 0">event_available</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-text-field
                            class="tarefa_personalizada"
                            v-model="tipoTarefaPersonalizada"
                            label="Personalizada"
                            single-line
                            full-width
                            hide-details
                          >
                          </v-text-field>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="tipoTarefaPersonalizada.length > 0 && tipoTarefaPersonalizada === form.fields.tipo">
                          <v-icon class="secondary--text">done</v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-dialog>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <v-divider></v-divider>
                <v-menu
                  lazy
                  v-model="menuData"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-left="40"
                  max-width="290px"
                  :nudge-top="140"
                >
                  <v-text-field
                    slot="activator"
                    prepend-icon="today"
                    v-model="form.fields.data_formatada"
                    label="Adicionar data"
                    name="data"
                    single-line
                    full-width
                    hide-details
                    readonly
                    class="label_fix"
                  >
                  </v-text-field>
                  <v-date-picker
                    v-model="form.fields.data"
                    locale="pt-br"
                    autosave
                    :allowed-dates="datasPermitidas"
                    :date-format="date => new Date(date).toLocaleDateString()"
                    :formatted-value.sync="form.fields.data_formatada"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 class="pa-0">   
                <v-divider></v-divider>             
                <v-dialog v-model="dialogUsuarios" fullscreen transition="dialog-bottom-transition" :overlay="false" @input="menuData = false">
                  <v-text-field
                    slot="activator"
                    v-model="form.fields.user_name"
                    label="Selecionar usuário"
                    v-validate="'required'"
                    name="usuario"
                    data-vv-as="usuário"
                    :error-messages="errors.has('usuario') ? errors.first('usuario') : []"
                    single-line
                    full-width
                    hide-details
                    prepend-icon="person"
                    readonly
                    class="label_fix"
                  >
                  </v-text-field>
                  <v-card>
                    <v-toolbar dark class="primary">
                      <v-btn icon @click.native="dialogUsuarios = false" dark>
                        <v-icon>keyboard_arrow_left</v-icon>
                      </v-btn>
                      <v-toolbar-title>Usuário</v-toolbar-title>
                    </v-toolbar>
                    <v-list two-line>
                      <v-list-tile v-for="(item, index) in users" v-bind:key="item.id" @click.native="selectUser(item.id)">
                        <v-list-tile-avatar class="avatar_sem_borda">
                          <img v-bind:src="item.avatar" class="avatar_borda" />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ item.cargo }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="item.id === form.fields.user_id">
                          <v-icon class="secondary--text">done</v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-dialog>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import HeadersDetalhesResumo from '../Imoveis/Headers/HeadersDetalhesResumo'

  export default {
    components: {
      HeadersDetalhesResumo
    },
    data () {
      return {
        imovelId: this.$route.params.id,
        dialogTarefasTipos: false,
        dialogUsuarios: false,
        menuData: false,
        datasPermitidas: (date) => {
          const today = new Date()
          return date.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0)
        },
        tipoTarefaPersonalizada: '',
        form: {
          fields: {
            tipo: '',
            data: '',
            data_formatada: '',
            user_id: '',
            user_name: ''
          }
        }
      }
    },
    mounted () {
      this.$primeUserRestrictions().then(() => {
        if (this.isLimitadoTarefas) {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'Usuários limitados por tarefas/vistorias não podem adicionar tarefas.'
          })
          this.$router.replace({ name: 'TarefasLista', params: { id: this.imovelId } })
          return
        }

        this.$store.dispatch('users/loadAssignableUsers')
      })
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      currentUser () {
        if (!this.$auth || typeof this.$auth.user !== 'function') return null
        return this.$auth.user()
      },
      isLimitadoTarefas () {
        return this.$hasUserRestrictionFlag('limitado_tarefas')
      },
      tarefaTipo () {
        return this.$store.getters['constants/tarefaTipo']
      },
      users () {
        return this.$store.getters['users/users']
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    watch: {
      tipoTarefaPersonalizada (value) {
        if (value.length > 0) {
          this.form.fields.tipo = value
        }
      },
      'form.fields.tipo' (value) {
        if (value !== this.tipoTarefaPersonalizada) {
          this.tipoTarefaPersonalizada = ''
        }
      },
      'form.fields.user_id' (value) {
        this.form.fields.user_name = _.find(this.users, { id: value }).name
      }
    },
    methods: {
      selectTarefa (item) {
        this.form.fields.tipo = item
        this.dialogTarefasTipos = false
      },
      selectUser (userId) {
        this.form.fields.user_id = userId
        this.dialogUsuarios = false
      },
      onSubmit () {
        if (this.isLimitadoTarefas) {
          return
        }

        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            axios.post(`${apiURL}/tarefas/${this.imovelId}`, this.form.fields).then((response) => {
              this.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: this.imovelId } })
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>

<style scoped>
  .label_fix { max-width: 250px; }
</style>



// WEBPACK FOOTER //
// TarefasAdicionar.vue?271773f4